import CareerRepository from '../Repositories/CareerRepository';

const careerRepository = new CareerRepository();

async function fetchJobDetails(jobId) {
  try {
    const response = await careerRepository.getJobDetails(jobId);
    return response.data;
  } catch (error) {
    return {};
  }
}

// eslint-disable-next-line import/prefer-default-export
export { fetchJobDetails };
